
import React, { useState, useEffect, useRef } from "react";
import PeopleIcon from "./../../../Assets/Images/CommanImages/ic_outline-people.png";
import { API_BASE_URL, FULL_API_BASE_URL } from "../../../Config/Config";

const FacultySelectorPreselected = ({ isMultiSelect, selectedSubjectId, onSelectionChange, isChecked = true, userId, excludeUserIds = [],
  selectedFacultiesProp = [], disabled = false,
}) => {
  const [searchKey, setSearchKey] = useState("");
  const [facultyList, setFacultyList] = useState([]);
  const [filteredFaculty, setFilteredFaculty] = useState([]);
  const [selectedFaculties, setSelectedFaculties] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    if (searchKey.length >= 1 && selectedSubjectId) {
      fetchFacultyList(searchKey, selectedSubjectId);
    }
  }, [searchKey, selectedSubjectId]);

  const fetchFacultyList = async (key, subjectId) => {
    try {
      if (!subjectId || key.length < 1) {
        setFilteredFaculty([]);
        return;
      }

      const accessToken = localStorage.getItem("other");

      const response = await fetch(
        // `${API_BASE_URL}/coaching-collaborator-api/api/v1/get-faculty-list-by-searchkey/?search_key=${key}&subject_id=${subjectId}`,
        `${FULL_API_BASE_URL}/get-faculty-list-by-searchkey/?search_key=${key}&subject_id=${subjectId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch faculty data.");

      const data = await response.json();
      // console.log(data);

      setFacultyList(data);
      // setFilteredFaculty(data);
      setFilteredFaculty(data.filter(f => !excludeUserIds.includes(f.user_id)));
    } catch (error) {
      // console.error("Error fetching faculty data:", error);
      setFacultyList([]);
      setFilteredFaculty([]);
    }
  };

  // Handle search input
  const handleSearchChange = (e) => {
    if (!isChecked) return;
    setSearchKey(e.target.value);
    setShowDropdown(true);
  };

  const handleSelectFaculty = (faculty) => {
    if (!isChecked) return;

    if (isMultiSelect) {
      setSelectedFaculties((prevSelected) => {
        const isAlreadySelected = prevSelected.some((f) => f.user_id === faculty.user_id);
        const newSelection = isAlreadySelected
          ? prevSelected.filter((f) => f.user_id !== faculty.user_id)
          : [...prevSelected, faculty];

        onSelectionChange(newSelection);
        return newSelection;
      });
    } else {
      setSelectedFaculties([faculty]);
      onSelectionChange([faculty]);
      setShowDropdown(false);
    }

    setSearchKey(""); // Clear search input after selection
  };

  // Clear all selected faculties
  const handleClearSelection = () => {
    setSelectedFaculties([]);
    onSelectionChange([]);
    setSearchKey("");
  };

  // Handle Backspace for removing the last selected faculty
  const handleKeyDown = (e) => {
    if (e.key === "Backspace" && searchKey === "" && selectedFaculties.length > 0) {
      setSelectedFaculties((prevSelected) => {
        const newSelection = prevSelected.slice(0, -1);
        onSelectionChange(newSelection);
        return newSelection;
      });
    }
  };

  // Display selected faculty names
  // const getSelectedFacultyNames = () => {
  //   return selectedFaculties.length > 0
  //     ? selectedFaculties.map((f) => `${f.emp_first_name} ${f.emp_middle_name} ${f.emp_last_name}`.trim()).join(", ")
  //     : "";
  // };

  const getSelectedFacultyNames = () => {
    return selectedFaculties.length > 0
      ? selectedFaculties
        .map((f) =>
          f.user_id === userId
            ? "Myself"
            : `${f.emp_first_name} ${f.emp_middle_name} ${f.emp_last_name}`.replace(/\s+/g, " ").trim()
        )
        .join(", ")
      : "";
  };


  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  // ADD THIS USEEFFECT TO FETCH THE PRE-SELECTED REVIEWER AND CREATER 
  useEffect(() => {
    setSelectedFaculties(selectedFacultiesProp || []);
  }, [selectedFacultiesProp]);

  return (
    <div className="input-wrapper" style={{ opacity: isChecked ? 1 : 0.8, position: "relative" }} ref={dropdownRef}>
      <div className="input-container">
        <input
          type="text"
          className="input-field"
          placeholder={selectedFaculties.length > 0 ? "" : "Search Faculty"}
          value={searchKey || getSelectedFacultyNames()}
          onChange={handleSearchChange}
          onKeyDown={handleKeyDown}
          // readOnly={!isChecked}
          // disabled={!isChecked}
          // style={{ opacity: isChecked ? 1 : 0.5 }}
          readOnly={!isChecked || disabled}
          disabled={!isChecked || disabled}
          style={{ opacity: !isChecked || disabled ? 0.5 : 1 }}
        />
        {/* {selectedFaculties.length > 0 && (
          <span className="clear-icon" onClick={handleClearSelection}>&times;</span>
        )} */}
        <img src={PeopleIcon} alt="People Icon" className="inside-icon-people" />
      </div>

      {/* Dropdown for selecting faculties */}
      {showDropdown && isChecked && filteredFaculty.length > 0 && (
        <div className="faculty-dropdown">
          {/* {filteredFaculty.map((faculty) => ( */}
          {[...filteredFaculty]
            .sort((a, b) => (a.user_id === userId ? -1 : b.user_id === userId ? 1 : 0))
            .map((faculty) => (

              <div key={faculty.user_id} className="faculty-item">
                {isMultiSelect ? (
                  <input
                    type="checkbox"
                    className="delete-question-checkbox-dqc"
                    checked={selectedFaculties.some((f) => f.user_id === faculty.user_id)}
                    onChange={() => handleSelectFaculty(faculty)}
                  />
                ) : null}
                <label onClick={() => handleSelectFaculty(faculty)}>
                  {faculty.user_id === userId
                    ? "Myself"
                    : `${faculty.emp_first_name} ${faculty.emp_middle_name} ${faculty.emp_last_name}`.replace(/\s+/g, " ").trim()}
                </label>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default FacultySelectorPreselected;
